import React from "react";
import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircle } from "react-icons/io";
import EAButton from "../shared/Buttons/EAButton";

interface IProps {
  onReturnToPrevious: () => void;
  onAddAnother: () => void;
  onGoToAccount: () => void;
}

const AddSubaccountSuccess: React.FC<IProps> = ({
  onReturnToPrevious,
  onAddAnother,
  onGoToAccount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="add-subaccount-success">
      <div className="add-subaccount-success__icon-wrapper">
        <IoMdCheckmarkCircle className="add-subaccount-success__icon" />
      </div>
      <h2 className="add-subaccount-success__title">Osoba została dodana pomyślnie!</h2>
      <p className="add-subaccount-success__subtitle">
        Nowa osoba jest już przypisana do Twojego konta. Możesz teraz zakupić dla niej karnet lub dodać kolejną osobę.
      </p>
      <div className="add-subaccount-success__buttons">
        <EAButton
          title={t("add_subaccount_return_to_checkout")}
          variant="filled"
          onClick={onReturnToPrevious}
        />
        <EAButton
          title="Dodaj kolejną osobę"
          variant="outlined"
          onClick={onAddAnother}
        />
        <EAButton
          title="Wróć do Mojego Konta"
          variant="outlined"
          onClick={onGoToAccount}
        />
      </div>
    </div>
  );
};

export default AddSubaccountSuccess;
